import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import {
  NavLink,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  useLocation,
} from 'react-router-dom';
import { GenericObject, SearchEntity, ProposalEntity } from 'v2/models';
import angleIcon from 'v2/icons/angle.svg';
import listIcon from 'v2/icons/list.svg';
import DataRequestDetail from './DataRequestDetail';
import styles from './dataRequestDetailsContainer.module.scss';
import { Badge } from 'react-bootstrap';
import useHistoryBackState from 'v2/hooks/useHistoryBackState';

export type SearchRouterProps = RouteComponentProps<{ id: string }>;

interface locationStateType {
  comingFromPath?: string;
}

export const DataRequestDetailsContainer = ({ match }: SearchRouterProps) => {
  const { path, url, params } = match;
  const comingFromPath = useLocation<locationStateType>().state?.comingFromPath;
  const proposalId = Number(params.id);
  const {
    backLinkTitle: backLinkTitleFromState,
    counterToGoBack,
    goBackHistory,
  } = useHistoryBackState(comingFromPath ?? '/');

  const backLinkTitle = backLinkTitleFromState || 'Data Requests';

  const proposalSelected: ProposalEntity = useSelector(
    (state: GenericObject) => {
      return state.proposals.multipleProposals?.find(
        (prop: ProposalEntity) => prop.id === proposalId
      );
    }
  );

  const LINKS = [
    {
      to: `${url}/detail`,
      label: 'Request Details',
      icon: listIcon,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!proposalSelected) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <div
        className={classnames('bg-white h-100', styles.searchDetailsContainer)}
      >
        <div
          className={classnames(
            'd-flex',
            'justify-content-between',
            'bg-light',
            'position-relative',
            'z-index-1',
            'page-title'
          )}
        >
          <div className="container-xl d-flex justify-content-between position-relative fix-bg-images">
            <div
              className={classnames(
                'align-items-center text-truncate align-self-center',
                styles.header
              )}
            >
              <div
                onClick={() => goBackHistory()}
                className={classnames(styles.prevLink, 'text-truncate')}
              >
                <img src={angleIcon} alt="angleIcon"></img>
                <h1
                  className={classnames('m-0 text-truncate pr-1')}
                  data-testid="go-back-title"
                >
                  {backLinkTitle}
                </h1>
              </div>
              <div
                className={classnames('text-truncate', styles.title)}
                data-testid="header_name"
              >
                {(proposalSelected.search as SearchEntity).name}
              </div>
            </div>
            <div
              className={classnames(styles.pills, 'd-flex align-items-center')}
            >
              {LINKS.map((link, index) => {
                return (
                  <NavLink
                    key={index}
                    to={{
                      pathname: link.to,
                      state: {
                        counterToGoBack: counterToGoBack - 1,
                        backLinkTitle,
                      },
                    }}
                    className="subNavLink"
                    data-cy="request-navbar-link"
                  >
                    <Badge
                      pill
                      className="mr-2 mr-lg-5 d-flex align-items-center"
                    >
                      <img src={link.icon} className="mr-2" alt="navIcon"></img>
                      {link.label}
                    </Badge>
                  </NavLink>
                );
              })}
            </div>
          </div>
        </div>
        <div
          className={classnames('bg-white h-100', styles.routeDetailContainer)}
        >
          <Switch>
            <Route path={`${path}/detail`}>
              <DataRequestDetail proposal={proposalSelected} />
            </Route>
          </Switch>
        </div>
      </div>
    </>
  );
};

export default DataRequestDetailsContainer;
